import ApiService from "@/services/api.service";

const route = 'commissions';

const actions = {
    get(_id) {
        return new Promise((resolve, reject) => {
            ApiService.get(route, _id).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    }
};

export default actions;